// pendingChatPromptVar target for the Roles and Competencies Ask AI sidebar.
export const rolesAndCompetenciesAskAiTarget = "roles-and-competencies";

// Starts the platform skill that sets up, imports or changes the framework:
// it reads what exists and asks which of those the admin wants.
export const roleFrameworkPrompt = (competencyLabel: string) =>
  `/build-role-framework:platform:build-role-framework Help me set up or change our role and ${competencyLabel} framework. Preview each change for my approval before saving.`;

export const importRoleFrameworkPrompt = (competencyLabel: string) =>
  `/import-role-framework:platform:import-role-framework I have an existing career ladder and ${competencyLabel} framework to bring in. I'll paste it here.`;

export const roleFrameworkChatUrl = (competencyLabel: string) =>
  `/ask-ai?${new URLSearchParams({
    p: roleFrameworkPrompt(competencyLabel),
    autosubmit: "1",
  })}`;

// Which part of the framework a Career Tracks page shows, for the Ask AI
// sidebar next to it, so "this track" or "add a level here" means the record
// on screen. Ids only: the assistant reads the records itself.
export const rolesPageContextMessage = (pathname: string) => {
  const on = (description: string, reader = "get_role_framework_setup") =>
    `Page context: the admin has Career Tracks settings open on ${description}. When they say "this" or "here", they mean it; read it with ${reader} before changing it.`;
  const idIn = (pattern: RegExp) => pathname.match(pattern)?.[1];

  const trackId = idIn(/\/career-track\/edit\/(\d+)/);
  if (trackId) {
    return on(`career track id ${trackId}`);
  }
  if (pathname.includes("/career-track/all-roles")) {
    return on("the company-wide competencies that apply to all roles");
  }
  if (pathname.includes("/career-track/all-competencies")) {
    return on("every competency, whoever it applies to");
  }
  const teamId = idIn(/\/career-track\/department\/(\d+)/);
  if (teamId) {
    return on(`the competencies of the department with team id ${teamId}`);
  }
  const userId = idIn(/\/career-track\/person\/(\d+)/);
  if (userId) {
    return on(
      `one person, user id ${userId}: their role and the responsibilities written for them alone`,
      `list_role_framework_employees with user_id ${userId}`,
    );
  }
  if (pathname.includes("/career-track/new")) {
    return on("a new, unsaved career track");
  }
  // The overview, or any page with nothing in particular on screen: says so,
  // so "this" stops meaning the last page's record.
  return `Page context: the admin has the Career Tracks overview open, not any one track, department, person or competency. If they say "this" or "here", ask which record they mean.`;
};
